import { ReactNode } from 'react';
import { PiPencilSimpleBold } from 'react-icons/pi';
import Text from '../text/Text';
import Button from '../button/Button';
import styles from './Card.module.css';

type CardProps = {
  title: string;
  children: ReactNode;
  isEditable?: boolean;
  editText?: string;
  onEdit?: () => void;
  onCardClick?: () => void;
};

const Card = ({
  title,
  children,
  isEditable = false,
  editText = '',
  onEdit = () => undefined,
  onCardClick = () => undefined,
}: CardProps) => (
  <div className={styles.wrapper}>
    <div className={styles.title}>
      <Text tag='h3' weight='bold' size='medium'>
        {title}
      </Text>
      {isEditable && (
        <Button
          type='transparent'
          width='content-width'
          onClick={onEdit}
          style={{
            fontSize: '16px',
            color: 'var(--color-text-gray)',
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            height: 'fit-content',
          }}
        >
          <PiPencilSimpleBold />
          &nbsp;&nbsp;
          {editText}
        </Button>
      )}
    </div>
    <div className={styles.card} onClick={onCardClick}>
      {children}
    </div>
  </div>
);

export default Card;
